import { Grid } from "@material-ui/core";
import { accountTypeItems, bankItems } from "../options";
import SectionCard from "../ui/SectionCard";
import { CreditCardIcon } from "../ui/icons";
import SegmentedPills from "../ui/fields/SegmentedPills";
import SelectField from "../ui/fields/SelectField";
import TextField from "../ui/fields/TextField";
import { StepViewProps } from "./types";

export default function Settlement({ state, handlers }: StepViewProps) {
  const { draft, errors } = state;
  const account = draft.accountDetails;

  return (
    <SectionCard title="Settlement details" icon={<CreditCardIcon size={18} />}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Account name"
            required
            value={account.accountName}
            error={errors.accountName}
            onChange={(v) => handlers.setAccountField("accountName", v)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            label="Name of bank"
            required
            value={account.bankName}
            items={bankItems}
            error={errors.bankName}
            onChange={(v) => handlers.setAccountField("bankName", v)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Account number"
            required
            value={account.bankAccountNumber}
            error={errors.bankAccountNumber}
            onChange={(v) => handlers.setAccountField("bankAccountNumber", v)}
          />
        </Grid>
        <Grid item xs={12}>
          <SegmentedPills
            label="Account type"
            required
            value={account.savingsAccount}
            options={accountTypeItems}
            error={errors.savingsAccount}
            onChange={(v) => handlers.setAccountField("savingsAccount", v)}
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
}
